export default __webpack_public_path__ + "static/media/flash01.d8af4a4c.png";